import React, {FC, useEffect, useState} from 'react';

import {ContentUnavailable} from 'components/content-unavailable';
import {FormPageContent} from 'components/form-page';
import {Spinner} from 'components/spinner';
import {UIBlocker} from 'components/ui-blocker';
import {loadMetadata, selectMetadata} from 'entities/metadata';
import {selectEntityData, resetLoadedData} from 'modules/data';
import {
    loadFormPageData,
} from 'modules/data/data-actions';
import {IFormEntityData} from 'modules/data/data-types';
import {IPageTemplateProps} from 'pages';
import {EEntityType} from 'shared/constants/entities';
import {useAppDispatch, useAppSelector} from 'store/config/hooks';

import './form-page.less';

interface IFormPageProps extends IPageTemplateProps {
    entityName: string;
}

export const FormPage: FC<IFormPageProps> = ({
    url,
    entityName,
}: IFormPageProps) => {
    const dispatch = useAppDispatch();
    const [isUnavailable, setIsUnavailable] = useState(false);
    const [isMetaLoading, setIsMetaLoading] = useState(false);
    const [isDataLoading, setIsDataLoading] = useState(false);
    const metadata = useAppSelector(state => selectMetadata(entityName, EEntityType.FORM)(state));
    const formData = useAppSelector(state => selectEntityData(entityName, EEntityType.FORM)(state) as IFormEntityData);
    const onHandleClose = async () => {
        await dispatch(loadFormPageData(entityName, url));
    };

    useEffect(() => {
        (async () => {
            if (!metadata) {
                setIsMetaLoading(true);
                await dispatch(loadMetadata(entityName, EEntityType.FORM));
                setIsMetaLoading(false);
            }

            if (!formData) {
                setIsDataLoading(true);
                await dispatch(loadFormPageData(entityName, url));
                setIsDataLoading(false);
            }
        })();
        return () => {
            dispatch(resetLoadedData(entityName, EEntityType.FORM));
        };
    }, []);

    useEffect(() => {
        if (!isMetaLoading) setIsUnavailable(!metadata);
    }, [metadata, isMetaLoading]);

    return (
        <UIBlocker
            content={(isMetaLoading || isDataLoading) && <Spinner />}
            opacity={0}
        >
            {
                isUnavailable ? <ContentUnavailable className="form-page__content-unavailable" /> : (
                    <FormPageContent
                        entityName={entityName}
                        formData={formData}
                        metadata={metadata}
                        onClose={onHandleClose}
                    />
                )
            }
        </UIBlocker>
    );
};
